<template>
    <b-overlay :show="pageBusy" variant="transparent">
        <b-card>
            <div class="row pt-0">
                <div class="col-12 pb-1">
                    <span class="font-weight-bolder">Filters</span>
                </div>
                <div class="col-lg-4 col-12 col-md-6">
                    <label>Date Range</label>
                    <flat-pickr
                        v-model="range"
                        class="form-control"
                        :config="{ mode: 'range'}"
                        />
                </div>
                <div class="col-lg-4 col-12 col-md-6">
                    <label>Region</label>
                    <v-select
                      v-model="searchRegion"
                      :options="regions"
                      :reduce="e=> e.value"
                    />
                </div>
                <!-- <div class="col-lg-4 col-12 col-md-6">
                    <label>Name</label>
                    <input v-model="searchName" type="text" class="form-control" placeholder="">
                </div> -->
                <div class="col-lg-4 col-12 col-md-6 pt-2 pt-lg-2">
                    <b-button variant="primary" @click="filterCities()"> <feather-icon icon="SearchIcon" /> Search</b-button>
                </div>
            </div>
        </b-card>
        <b-card>
            <div class="pb-1">
              <b-button @click="triggerAddCity()" variant="primary">Add City</b-button>
            </div>
            <b-modal id="add-city-modal" centered ok-title="Save" @ok="submittedCity" :title="city.id ? 'Update City': 'Create City'" no-close-on-backdrop no-close-on-esc>
                <div class="row">
                    <div class="col-12">
                        <div class="mt-1">
                          <label for="">Name</label> <small class="text-danger">*</small>
                          <b-form-input v-model="city.name" autofocus />
                        </div>
                    </div>
                    <div class="col-12">
                      <div class="mt-1">
                        <label for="">Country</label> <small class="text-danger">*</small>
                        <v-select
                          v-model="city.country"
                          :options="countries"
                          :reduce="e=> e.value"
                          :clearable="false"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="mt-1">
                        <label for="">Region</label> <small class="text-danger">*</small>
                        <v-select
                          v-model="city.region"
                          :options="regions"
                          :reduce="e=> e.value"
                          :clearable="false"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                        <div class="mt-1">
                          <label for="">Description</label>
                          <b-form-textarea v-model="city.desc" />
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="mt-1">
                          <label for="">French description</label>
                          <b-form-textarea v-model="city.frDesc" />
                        </div>
                    </div>

                </div>
            </b-modal>
            <b-overlay :show="itemBusy">
                <b-table
                    class="rounded border"
                    :items="items"
                    :fields="fields"
                    :per-page="10"
                    :current-page="1"
                    responsive
                >

                    <template #head()="scope">
                        <div class="text-nowrap text-primary">
                        {{ scope.label }}
                        </div>
                    </template>
                    <template #cell(name)="data">
                        <span class="text-nowrap" v-if="data.item.id">
                            <div class="d-flex align-items-center">
                                <div class="pr-1">
                                    <b-avatar variant="primary" icon="people" v-if="data.item.image"></b-avatar>
                                    <b-avatar variant="primary" icon="people" v-else>
                                      <template #default>
                                        <div>
                                          <feather-icon icon="TargetIcon"></feather-icon>
                                        </div>
                                      </template>
                                    </b-avatar>
                                </div>
                                <div class="w-100">
                                    {{data.value}}
                                </div>
                            </div>
                        </span>
                    </template>
                    <template #cell(status)="data">
                        <span class="text-nowrap" v-if="data.item.id">
                            <b-badge v-if="data.value == 1" variant="success">
                                Visible
                            </b-badge>
                            <b-badge variant="danger" v-else>
                                Hidden
                            </b-badge>
                        </span>
                    </template>
                    <template #cell()="data">
                        <div class="text-nowrap pt-1">
                            {{data.value}}
                        </div>
                    </template>
                    <template #cell(createdAt)="data">
                        <div class="text-nowrap pt-1" v-if="data.item.id">
                            {{ date(data.value) }}
                        </div>
                    </template>
                    <template #cell(updatedAt)="data">
                        <div class="text-nowrap pt-1" v-if="data.item.id">
                            {{ date(data.value) }}
                        </div>
                        <div v-else class="p-1">

                        </div>
                    </template>
                    <template #cell(actions)="data">
                      <b-dropdown
                        variant="link"
                        no-caret
                        :right="$store.state.appConfig.isRTL"
                        v-if="data.item.id"
                      >
                        <template #button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="align-middle text-body"
                          />
                        </template>
                        <b-dropdown-item @click="triggerEditCity(data.item)">
                          <feather-icon icon="EditIcon" />
                          <span class="align-middle ml-50">Edit</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="triggerToggleVisibility(data.item.cityId)">
                          <feather-icon icon="TrashIcon"  />
                          <span class="align-middle ml-50">Toggle visibility</span>
                        </b-dropdown-item>
                        <b-dropdown-item :to="'/properties/manage?cityId=' + data.item.cityId">
                          <feather-icon icon="EyeIcon"  />
                          <span class="align-middle ml-50">See properties</span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                    <template #cell(description)="data">
                        <span class="pb-1 text-truncate d-block city-content text-primary cursor-pointer text-center" @click="showModal(data.value)">
                            {{data.value}}
                        </span>
                    </template>
                    <template #cell(region)="data">
                        <span class="pb-1" v-if="data.item.regionId">
                            {{getRegion(data.item.regionId)}}
                        </span>
                    </template>
                    <template #cell(shortDescription)="data">
                        <span class="pb-1 text-truncate d-block city-content text-primary cursor-pointer text-center" @click="showModal(data.value)">
                            {{data.value}}
                        </span>
                    </template>
                    <template #cell(images)="data">
                        <span class="text-nowrap" v-if="data.item.id">
                            <small class="font-italic" v-if="!data.value.length">
                               No image
                            </small>
                            <b-button v-else variant="outline-primary" size="sm" pill v-b-toggle.images @click="images = data.value">
                                See images
                            </b-button>
                        </span>
                    </template>
                </b-table>
            </b-overlay>
            <div class="d-flex p-1">
                <div class="w-100">
                    Page <span class="text-primary"> {{currentPage}}</span> of <span class="text-primary">{{Math.ceil(totalRows/10)}}</span>
                </div>
                <div class="w-100">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="10"
                        aria-controls="users-table"
                        align="right"
                        size="sm"
                        class="my-0"
                        @page-click="loadNewPage"
                    />
                </div>
            </div>
            <b-sidebar
                id="images"
                sidebar-class="sidebar-lg"
                bg-variant="white"
                backdrop
                no-close-on-backdrop
                >
                <div v-for="(image, i) in images" :key="i">
                    <div class="p-1">
                        <b-img :src="image" rounded="" fluid center>

                        </b-img>
                    </div>
                </div>
            </b-sidebar>
        </b-card>
    </b-overlay>


</template>

<script>

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Utils from '@/utils/index';
import API from './api'

const toast = useToast()
export default {
    name: 'Cities',
    components: {
        flatPickr,
        vSelect,
    },
    data() {
        return {
          regions: [],
          countries: [],
          searchRegion: '',
            date: Utils.formatDate,
            city: {
                name: '',
                region: '',
                regionId: '',
                country: '',
                countryId: '',
                desc: '',
            },
            cityType: 1,
            cityTypes:[
                {label: 'Paid', value: true },
                {label: 'Free', value: false }
            ],
            currentPage: 1,
            totalRows: 10,
            range: '',
            searchDate: '',
            dateRange: '',
            searchName: '',
            status: 'All',
            statusOptions: [
                {'label':'Pending',"value": 1},
                {'label':'Processed',"value": 2},
                {'label':'All' },

            ],
            checked: '',
            images: [],
            items: [],
            fields: [
                {key: 'name', label: 'Name'},
                // {key: 'desc', label: 'Description'},
                {key: 'region', label: 'Region'},
                {key: 'status', label: 'Visible'},
                {key: 'createdAt', label: 'Created At'},
                {key: 'updatedAt', label: 'Updated At'},
                {key: 'actions', label: 'Actions'},
            ],
            searchParams: {},
            itemBusy: false,
            pageBusy: false,
        }
    },
    watch: {
        range(newRange, oldRange) {
            newRange = newRange.split(' to ');
            if(newRange.length === 2) {
                this.searchDate = {
                    from: newRange[0],
                    to: newRange[1]
                }
            }else if(newRange[0].length == 10) {
                 this.searchDate = {
                    from: newRange[0],
                    to: newRange[0]
                }
            }else {
                this.searchDate = '';
            }
        },
    },
    created() {
        this.items = Utils.completeTable();
        this.getCities();
        this.getRegions();
        this.getCountries();
    },
    methods: {
      processRegion(data = {}){
        return {
          value: data.id,
          regionId: data.regionId,
          label: data.name
        }
      },
      processCountry(data = {}){
        return {
          value: data.id,
          countryId: data.countryId,
          label: data.name
        }
      },
      getCountries(pageNum = 1){
        API.getCountries({pageNum, pageSize: 50}).then(res=>{
          if(res.success && res.data && res.data.list) {
            if(pageNum == 1){
              this.countries = res.data.list.map(e=> this.processCountry(e));
            }else{
              this.countries.push(res.data.list.map(e=> this.processCountry(e)));
            }
            if(res.data.hasMore){
              this.getCountries(pageNum + 1);
            }
          }
        }).catch(err=>{
          console.error(err);
        });
      },
      getRegions(pageNum = 1){
        API.getRegions({pageNum, pageSize: 50}).then(res=>{
          if(res.success && res.data && res.data.list) {
            if(pageNum == 1){
              this.regions = res.data.list.map(e=> this.processRegion(e));
            }else{
              this.regions.push(res.data.list.map(e=> this.processRegion(e)));
            }
            if(res.data.hasMore){
              this.getRegions(pageNum + 1);
            }
          }
        }).catch(err=>{
          console.error(err);
        });
      },
      triggerAddCity(){
        this.resetCity();
        this.$bvModal.show('add-city-modal');
      },
      getRegion(data = ''){
        const region = this.regions.find(r => r.regionId == data);
        if(region){
          return region.label
        }
        return data
      },
      resetCity(){
        this.city = {
            name: '',
            region: '',
            regionId: '',
            desc: '',
        }
      },
      triggerEditCity(city){
        this.city = {...city};
        this.$bvModal.show('add-city-modal');
      },
      submittedCity(e){
        e.preventDefault();
        if(!this.city.name){
          this.showToast('Please enter name');
          return 0;
        }
        if(!this.city.region){
          this.showToast('Please select region');
          return 0;
        }
        if(!this.city.country){
          this.showToast('Please select country');
          return 0;
        }
        const region = this.regions.find(r => r.value == this.city.region);
        if(!region){
          this.showToast('Please reselect region and try again');
          return 0;
        }
        this.city.regionId = region.regionId;
        
        const country = this.countries.find(r => r.value == this.city.country);
        if(!country){
          this.showToast('Please reselect country and try again');
          return 0;
        }
        this.city.countryId = country.countryId;

        const api = this.city.id? 'editCity': 'addCity';
        API[api]({...this.city}).then(res => {
          if(res.success){
            if(this.city.cityId){
              this.items = this.items.map(item=>{
                if(item.cityId == this.city.cityId){
                  item = res.data;
                }
                return item;
              })
            }else{
                this.items.unshift(res.data);
                this.getCities();
            }
            this.resetCity();
            this.$bvModal.hide('add-city-modal');
          }
        }).catch(err=>{
          console.log(err);
        })
      },
        loadNewPage(e,page) {
            e.preventDefault();
            this.getCities(page);
        },
        getCities(pageNum = 1) {
            // this.pageBusy = true;
            API.getCities({ ...this.searchParams, pageNum}).then(res => {
                this.pageBusy = false;
                if(res.success && res.data) {
                    this.currentPage = pageNum;
                    this.items = Utils.completeTable(res.data.list);
                    this.totalRows = res.data.total;
                }
            }).catch(() => {
                this.pageBusy = false;
                this.showToast('Failed to get cities');
            })
        },
         filterCities() {
            this.searchParams = {};
            if(this.searchName) {
                this.searchParams.name = this.searchName;
            }
            if(this.searchRegion) {
                this.searchParams.region = this.searchRegion;
            }
            if(this.searchDate && this.searchDate.from) {
                this.searchParams.startDate = this.searchDate.from + ' 00:00:00';
                if(!this.searchDate.to) {
                    this.this.searchDate.to = this.searchDate.from
                }
                this.searchParams.endDate = this.searchDate.to + ' 23:59:59';
            }

            this.getCities(1);
            this.currentPage = 1;
        },
        showToast(message, icon, variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message || 'Error fetching cities',
                    icon: icon || 'InfoIcon',
                    variant: variant || 'danger',
                },
            })
        },
        showModal(description) {
            this.$bvModal.msgBoxOk(description, {
            title: 'City',
            size: 'md',
            buttonSize: 'md',
            okVariant: 'primary',
            headerClass: 'p-2 border-bottom-0',
            bodyClass: 'text-break',
            footerClass: 'p-2 border-top-0',
            centered: true
            })
            .then(value => {
                // value returns true if ok was clicked
            })
            .catch(err => {
                // An error occurred
            })
        },
        triggerToggleVisibility(id) {
            this.$bvModal.msgBoxConfirm("Are you sure you want to toggle visibility", {
            title: 'Toggle',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            bodyClass: 'text-break',
            footerClass: 'p-2 border-top-0',
            cancelTitle: 'Cancel',
            centered: true
            })
            .then(value => {
                if(value){
                    this.toggleVisibility(id);
                }
            })
            .catch(err => {
                // An error occurred
            })
        },
        toggleVisibility(id) {
          API.toggleCityVisibility(id).then(res => {
            this.pageBusy = false;
            if(res.success) {
              this.items = this.items.map(e=>{
                if(e.cityId == res.data.cityId){
                    e = res.data;
                }
                return e
              })
                // this.getCities(this.currentPage);
                this.showToast('Property type toggled successfully', 'CheckIcon', 'success');
            }
          }).catch(() => {
              this.pageBusy = false;
              this.showToast('Failed to toggle property type');
          })
        }
    }
}
</script>

<style lang="scss" scope>

    @import '@core/scss/vue/libs/vue-select.scss';
    @import '@core/scss/vue/libs/vue-flatpicker.scss';

    .city-content{

        max-width: 100px !important;
    }
    .city-content:hover{
        transform: scale(1.2);
    }
</style>